<template>

<div class="main am-margin-bottom-sm" >
    <div class="main-context" style=" overflow: hidden;">
        <div class="nav-bar">
            <ul >
                <li>
                    <router-link to="/">首页</router-link>
                </li>
                <li v-for="(item,index) in list" :key="index" :class="[ ($route.params.portId||'').length>6&&(item.type_id||'').length>6&&$route.params.portId.indexOf(item.type_id)!=-1?'active':'']">
                    <template v-if="item.type_id">
                        <router-link v-if="item.type_id"  :to="'/list/'+item.type_id"> 
                        {{item.type_name}}
                            </router-link>
                    </template>
                    <template v-else>
                        {{item.type_name}}
                    </template>
                    
                </li>
            </ul>
        </div>

    </div>
</div>
 
</template>

<script>
export default {
    name:'navList',
    props:["list"],
    mounted(){
    }
}
</script>

<style lang="scss">
.nav-bar{
    background-repeat: no-repeat,repeat-x;
    background-position: left top,bottom;
    font-size: 14px;
    padding: 8px 8px 8px 24px;
    position: relative;
    left: -12px;;
    border-radius: 16px;
    display: inline-block;
    background-image: linear-gradient(0deg, #f9810d 0%, #f99516 100%);
    background-color: #f9810d;
    li{
        margin-right: 12px;
     color: white;
        display: inline-block;
        &.active{
            font-weight: bold;
        }
        &::after{
            content: ">";
             margin-left: 12px;
            color: white;
        }
        &:last-child{
            &::after{
                display: none;
            }
        }
    }
}
</style>
